import {Component, inject} from '@angular/core';
import {DeviceAlarm, GatewayAlarm, MetricInstanceAlert} from "../../../models/diagnostic/PartitionAlarm";
import {BaseComponentWithDrawer} from "../../registry/base-component-with-drawer.component";
import {TimeUnitEnum} from "../../../enums/dashboard/TimeUnitEnum";
import {DatePipe} from "@angular/common";
import {TypeOfDateSettingsEnumAlarms} from "../../../enums/dashboard/TypeOfDateSettingsEnumAlarms";
import {AlarmEvent} from "../../../models/diagnostic/AlarmEvent";

@Component({
  selector: 'app-common',
  template: 'NO-UI',
  styleUrls: ['./baseAlarm.component.css']
})
export class BaseAlarmComponent extends BaseComponentWithDrawer {

  protected searchInput: string;

  protected collapsedTags = true;

  protected startDate: string | number | Date;

  protected endDate: string | number | Date;

  protected realtimeValue: number = 1;

  protected realTimeUnit: TimeUnitEnum = TimeUnitEnum.HOURS;

  protected lastEventsNumber: number = 20;

  protected typeOfDateSettings: TypeOfDateSettingsEnumAlarms = TypeOfDateSettingsEnumAlarms.LAST_EVENTS;

  protected readonly TypeOfDateSettingsEnum = TypeOfDateSettingsEnumAlarms;

  protected datePipe: DatePipe = inject(DatePipe);

  constructor() {
    super();
    this.searchInput = "";
    this.endDate = new Date();
    this.startDate = new Date(new Date().setDate(new Date().getDate() - 1));
  }

  getBySearch<T extends DeviceAlarm | GatewayAlarm | MetricInstanceAlert>(array: T[]): T[] {
    if (!!this.searchInput) {
      return array.filter((x: DeviceAlarm | GatewayAlarm | MetricInstanceAlert) => {
        return x.name.toLowerCase().includes(this.searchInput.toLowerCase());
      });
    } else {
      return array;
    }
  }

  getByFilters<T extends DeviceAlarm | GatewayAlarm | MetricInstanceAlert>(array: T[], filters: number[]) {
    return array.filter((x: DeviceAlarm | GatewayAlarm | MetricInstanceAlert) => {
      if (x.alarmStatus !== undefined)
        return filters.includes(x.alarmStatus) || x.alarmStatus === null;
      else
        return false;
    })
  }

  getTsFromRealTime() {
    let now = new Date();
    switch (this.realTimeUnit) {
      case TimeUnitEnum.MINUTES:
        return new Date(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours(), now.getMinutes() - this.realtimeValue, now.getSeconds());
        break;
      case TimeUnitEnum.HOURS:
        return new Date(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours() - this.realtimeValue, now.getMinutes(), now.getSeconds());
        break;
      case TimeUnitEnum.DAYS:
        return new Date(now.getFullYear(), now.getMonth(), now.getDate() - this.realtimeValue, now.getHours(), now.getMinutes(), now.getSeconds());
        break;
      case TimeUnitEnum.WEEKS:
        return new Date(now.getFullYear(), now.getMonth(), now.getDate() - this.realtimeValue * 7, now.getHours(), now.getMinutes(), now.getSeconds());
        break;
      case TimeUnitEnum.MONTHS:
        return new Date(now.getFullYear(), now.getMonth() - this.realtimeValue, now.getDate(), now.getHours(), now.getMinutes(), now.getSeconds());
        break;
      case TimeUnitEnum.YEARS:
        return new Date(now.getFullYear() - this.realtimeValue, now.getMonth(), now.getDate(), now.getHours(), now.getMinutes(), now.getSeconds());
        break;
    }
  }

  parseDateFromNumber(ts?: number) {
    return this.datePipe.transform(ts, 'dd/MM/yyyy HH:mm:ss')?? "---";
  }

  parseDateFromObject = (row: Date) => {
      return this.datePipe.transform(row, 'dd/MM/yyyy HH:mm:ss')?? "---";
  };
}
